import React from "react";
import AppRouter from "./Router";
import "./styles/styles.css";

const App = () => {
  return <AppRouter />;
};

export default App;
